import React, {Component} from 'react';
import styled from 'styled-components'
import {compose} from "redux";
import {connect} from "react-redux";
import {withFirestore, firestoreConnect, populate, useFirestoreConnect} from "react-redux-firebase";

import {setCompanyCallsView, setSelectedEmployee} from "../../redux/uxEnhance/action";

import { Checkbox } from 'antd';
import { TreeSelect } from 'antd';
import {COMPANY_DB_PATH} from "../../constants/DB_PATHS";



const StyledOptionsContainer = styled.div`

`
const { TreeNode } = TreeSelect;
class QueryOptions extends Component {
    constructor() {
        super();
        this.state={
            exEmp: null,
            currEmp: null,
            active: true,
            taken: false,
        }
    }



    render() {
        console.log('QO')
        console.log(this.props)
        console.log(this.state)
        if(this.props.company && this.props.company.employees){
            let currentEmpList = {}
            this.props.company.employees.forEach(emp=>{

                this.props.firestore.collection('users').doc(emp).get().then(doc=>{
                    currentEmpList[emp] = doc.data()
                    console.log(currentEmpList)
                    if(Object.keys(currentEmpList).length === this.props.company.employees.length &&
                        !this.state.currEmp
                    ){
                        this.setState({currEmp: currentEmpList})
                    }
                }).catch(err=>{
                    console.log('Error getting current employees data', err)
                })

            })


        }
        if(this.props.company && this.props.company.exEmployees){
            let exEmpList = {}
            this.props.company.exEmployees.forEach(emp=>{
                this.props.firestore.collection('users').doc(emp).get().then(doc=>{
                    exEmpList[emp] = doc.data()
                    if(Object.keys(exEmpList).length === this.props.company.employees.length &&
                        !this.state.currEmp
                    ){
                        this.setState({exEmp: exEmpList})
                    }
                }).catch(err=>{
                    console.log('Error getting ex-employees data', err)
                })
            })

        }

        return (
            <StyledOptionsContainer>
                <Checkbox
                    checked={this.state.active}
                    onChange={e=>{
                        this.setState({active: e.target.checked})
                    }}
                >active</Checkbox>
                <Checkbox
                    checked={this.state.taken}
                    onChange={e=>{
                        this.setState({taken: e.target.checked})
                    }}
                >taken</Checkbox>
                <TreeSelect
                    style={{ width: '100%' }}
                    treeDefaultExpandedKeys={['parent-1', ]}
                    defaultValue={null}
                    disabled={!this.state.taken}
                    onChange={id=>{
                        console.log(id)
                        if(this.state.exEmp && this.state.exEmp[id]){
                            console.log('try1')

                            return this.props.setSelectedEmployee(
                                id,
                                this.state.exEmp[id].firstN,
                                this.state.exEmp[id].lastN
                            )

                        }
                        if(this.state.currEmp && this.state.currEmp[id]){
                            console.log('try2')
                            return this.props.setSelectedEmployee(
                                id,
                                this.state.currEmp[id].firstN,
                                this.state.currEmp[id].lastN
                            )
                        }
                        return this.props.setSelectedEmployee('', '', '')


                    }}
                >
                    <TreeNode value={null} title={'Osszes'} key={null}/>
                    <TreeNode value={'parent-1'} title={'Alkalmazottak'}
                              disabled
                    >

                        {this.state.currEmp ?

                            Object.entries(this.state.currEmp).map((e,i)=>{
                                let id = e[0]
                                let data = e[1]
                                return(
                                    <TreeNode value={id} title={data.firstN+' '+data.lastN} key={id}/>
                                )
                            })

                            :

                            null
                        }

                    </TreeNode>
                    <TreeNode value={'parent 2'} title={'Ex-Alkalmazottak'}
                              disabled
                    >

                        <TreeNode value={'id2'} title={'kinn'}/>

                    </TreeNode>
                </TreeSelect>
            </StyledOptionsContainer>
        );
    }
}

const mapStateToProps = state => {
    return{
        selectedEmp: state.uxEnhance.selectedEmp,
        //companyCallsView: state.uxEnhance.companyCallsView
    }
}

const mapDispatchToProps = dispatch => {
    return{
        //setCompanyCallsView: (view) => dispatch(setCompanyCallsView(view)),
        setSelectedEmployee: (id, firstN, lastN) => dispatch(setSelectedEmployee(id, firstN, lastN))
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    connect(
        ({firebase: {auth, profile}}) => ({
            auth,
            profile,
        })
    ),
    firestoreConnect(state=>{
        return[{
            collection: COMPANY_DB_PATH,
            doc: state.auth.uid,
            storeAs: 'company'
        }]
    }),
    connect((state, props) => ({
        company: state.firestore.data.company,
    })),

)(QueryOptions)